import withSSRModel from "hoc-lib/ssrModelMapper"
import { connect } from "react-redux"
import { withSpacing } from "hoc-lib/spacing"
import { setModalId } from "actions-lib/setModalId"
import { getPersonalization } from "actions-lib/getPersonalization"
import SingleColumnText from "./SingleColumnText"

const mapStateToProps = (state) => ({
  customerSelections: state.customerSelections,
  isRecycleQuizPage: state.setIsRecycleQuizPage.isRecycleQuizPage,
  isQuizCompleted: state.setIsRecycleQuizPage.isQuizCompleted,
  guidelines: state.myServices.guestBulkPickupGuidelinesData?.data,
})

const mapDispatchToProps = {
  setModalId,
  getPersonalization,
}

const SingleColumnTextWithSpacing = withSSRModel(
  withSpacing({
    useRebrandedspacingColor: true,
  })(SingleColumnText),
)

const ConnectedSingleColumnText = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SingleColumnTextWithSpacing)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default ConnectedSingleColumnText
